import { combineReducers } from 'redux';
import specialHostsReducer from './specialHostsReducer';
import specialHostReducer from './specialHostReducer';

export default combineReducers({
  specialHosts: specialHostsReducer,
  specialHost: specialHostReducer,
});
